module.exports = __webpack_public_path__ + "static/media/Drone_3.16b7de20.jpg";